import { IAppSettings } from "@types";

const DEFAULT_OPTIONS_MAX_WIDTH = "28rem";
const DEFAULT_OPTIONS_MIN_WIDTH = "240px";
const DEFAULT_CAROUSEL_RECTANGLE_CARD_WIDTH = 236;
const DEFAULT_CAROUSEL_SQUARE_CARD_WIDTH = 250;
const DEFAULT_CAROUSEL_RECTANGLE_IMAGE_HEIGHT = 172;
const DEFAULT_CAROUSEL_SQUARE_IMAGE_HEIGHT = 250;
const DEFAULT_CAROUSEL_BUTTON_WIDTH = "230px";

type IRichMessageSettings = IAppSettings["richMessage"];

export const toCssSize = (value?: number | string) => {
  if (value === undefined || value === null || value === "") {
    return undefined;
  }

  return typeof value === "number" ? `${value}px` : value;
};

export const toPixelNumber = (
  value: number | string | undefined,
  fallback: number,
) => {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string") {
    const matchedValue = value.match(/^(\d+(?:\.\d+)?)px$/);

    if (matchedValue) {
      return Number(matchedValue[1]);
    }
  }

  return fallback;
};

export const resolveOptionsLayout = (richMessage?: IRichMessageSettings) => {
  const containerWidth = toCssSize(richMessage?.buttons?.containerWidth);
  const buttonStyleOverrides = richMessage?.buttons?.buttonStyle;

  return {
    containerStyle: containerWidth
      ? {
          width: containerWidth,
          minWidth: containerWidth,
          maxWidth: containerWidth,
        }
      : {
          minWidth: DEFAULT_OPTIONS_MIN_WIDTH,
          maxWidth: DEFAULT_OPTIONS_MAX_WIDTH,
        },
    buttonStyle: {
      ...buttonStyleOverrides,
    },
  };
};

export const resolveCarouselLayout = (
  richMessage: IRichMessageSettings | undefined,
  imageAspectRatio?: "rectangle" | "square",
  columnCount?: number,
) => {
  const isSquare = imageAspectRatio === "square";
  const defaultCardWidth = isSquare
    ? DEFAULT_CAROUSEL_SQUARE_CARD_WIDTH
    : DEFAULT_CAROUSEL_RECTANGLE_CARD_WIDTH;
  const defaultImageHeight = isSquare
    ? DEFAULT_CAROUSEL_SQUARE_IMAGE_HEIGHT
    : DEFAULT_CAROUSEL_RECTANGLE_IMAGE_HEIGHT;
  const cardWidth = richMessage?.carousel?.cardWidth ?? defaultCardWidth;
  const imageHeight = richMessage?.carousel?.imageHeight ?? defaultImageHeight;
  const buttonStyleOverrides = richMessage?.carousel?.buttonStyle;
  const hasCustomButtonWidth = buttonStyleOverrides?.width !== undefined;
  const shouldHideArrows = (columnCount ?? 0) <= 1;

  return {
    cardWidth,
    cardWidthStyle: toCssSize(cardWidth),
    imageHeight,
    imageHeightStyle: toCssSize(imageHeight),
    imageLoaderWidth: toPixelNumber(cardWidth, defaultCardWidth),
    imageLoaderHeight: toPixelNumber(imageHeight, defaultImageHeight),
    buttonStyle: {
      maxWidth: hasCustomButtonWidth
        ? undefined
        : DEFAULT_CAROUSEL_BUTTON_WIDTH,
      ...buttonStyleOverrides,
    },
    shouldHideArrows,
  };
};
